import { authRoutes, mainDashboardRoutes, otherPublicRoutes, rootRoute, settingsRoutes } from './constants';
import { flattenRoutes } from './utils/routeHelpers';

const authPartialProtectedRoutes = [rootRoute, ...mainDashboardRoutes];
const authProtectedRoutes = [...settingsRoutes];
const publicRoutes = [...authRoutes, ...otherPublicRoutes];

const authPartialProtectedFlattenRoutes = flattenRoutes([...authPartialProtectedRoutes]);
const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);

export {
  publicRoutes,
  authPartialProtectedRoutes,
  authPartialProtectedFlattenRoutes,
  authProtectedFlattenRoutes,
  authProtectedRoutes,
  publicProtectedFlattenRoutes,
};
